import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "@johnpaul/jp-api-client";
import { getClientToken } from "@companion-core/shared/app/Utils/apiClient";

export const useVCESToken = (enabled = true) => {
  return useQuery({
    queryKey: ["vcesToken"],
    queryFn: async () => {
      const token = await getClientToken();
      return client.vces.getToken(token);
    },
    enabled,
    retry: false,
  });
};

export const useVCESValidate = () => {
  return useMutation({
    mutationFn: async (correlationId: string) => {
      const token = await getClientToken();
      return client.vces.validate(token, correlationId);
    },
    retry: false,
    gcTime: 0,
  });
};
